import MixinGame from './game'
import Component, { mixins } from 'vue-class-component'
import collect, { Collection } from 'collect.js'
import { Pawn, Player } from '@/services/store/types'
import ModelConnection from '@/models/connection'
import { IO } from '@/interfaces/connection'
import { ioTypes } from '@/constants/io'
import ModelMolecule from '@/models/molecule'
import { globalEvents } from '@/constants/events'
import { uuid } from '@/shared/utils'
import { visibleChainLengthMolecules } from '@constants/molecule'

@Component
export default class MixinPlayer extends mixins(MixinGame) {
  public get playerPawns(): Collection<Pawn> {
    return collect(this.pawns)
  }

  public get playerTeamPawns(): Collection<Pawn> {
    return this.playerPawns
      .filter((pawn: Pawn) => pawn.teamID === this.activePlayer.teamID || pawn.teamID === null)
  }

  public playerHasPawnsForConnection(connection: ModelConnection): boolean {
    let pawnsPresent = true

    connection.inputs
      .filter((input: IO) => input.objectType === ioTypes.MOLECULE)
      .each((input: IO) => {
        const pawnAmount: number = this.playerTeamPawns
          .filter((pawn: Pawn) => pawn.moleculeID === input.objectID)
          .count()

        if (pawnAmount < input.quantity) {
          pawnsPresent = false
          const modelMolecule: ModelMolecule = this.$molecules.find(input.objectID)
          const moleculeTitle: string = modelMolecule.title.includes('right') ? 'vetzuur' : modelMolecule.title
          this.$flits.error(`Je hebt ${input.quantity}x ${moleculeTitle} nodig voor deze overgang.`)
        }
      })

    return pawnsPresent
  }

  public playerProcessConnectionUsage(connection: ModelConnection, pawn: Pawn) {
    let highestChainLength = 0
    let highestDoubleBindings = 0

    connection.inputs
      .filter((input: IO) => input.objectType === ioTypes.MOLECULE)
      .each((input: IO) => {
        for (let i = input.quantity - 1; i >= 0; i--) {
          let deletePawn: Pawn

          if (input.objectID === pawn.moleculeID && i === input.quantity - 1) {
            deletePawn = pawn
          } else {
            const molecule: ModelMolecule = this.$molecules.find(input.objectID)
            deletePawn = this.getPawn(molecule)
          }

          // logic only applies for fat chain building / breaking down
          if (visibleChainLengthMolecules.includes(deletePawn.moleculeID)) {
            highestChainLength = Math.max(highestChainLength, deletePawn.chainLengths[i])
            highestDoubleBindings = Math.max(highestDoubleBindings, deletePawn.doubleBindings[i])
          }

          this.storeRemovePawnByID(deletePawn.id)
        }
      })

    connection.outputs
      .filter((output: IO) => output.objectType === ioTypes.MOLECULE)
      .each((output: IO) => {
        for (let i = 0; i < output.quantity; i++) {

          let chainLength: number = highestChainLength
          let doubleBindings: number = highestDoubleBindings

          if (visibleChainLengthMolecules.includes(pawn.moleculeID)) {
            chainLength = Math.max(pawn.chainLengths[i], highestChainLength)
            doubleBindings = Math.max(pawn.doubleBindings[i], highestDoubleBindings)
          }

          if (chainLength) {
            chainLength += connection.chainlengthModifier

            if (chainLength !== 18) {
              doubleBindings = 0
            }
          }

          const molecule: ModelMolecule = this.$molecules.find(output.objectID)
          let targetPlayer: Player = this.activePlayer

          if (pawn.playerID !== null) {
            targetPlayer = this.players.find((player: Player) => player.id === pawn.playerID) as Player
          }

          this.storeAddPawn({
            id: uuid(),
            team: this.activeTeam,
            player: targetPlayer,
            chainLengths: [chainLength],
            doubleBindings: [doubleBindings],
            molecule,
          })

          this.$bus.$emit(globalEvents.PAWN_DROPPED_ON_MOLECULE, {
            molecule,
            chainLength,
          })
        }
      })
  }
}
